import { render, staticRenderFns } from "./VTabs.vue?vue&type=template&id=afeee9d6&lang=pug&"
import script from "./VTabs.vue?vue&type=script&lang=js&"
export * from "./VTabs.vue?vue&type=script&lang=js&"
import style0 from "./VTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports